import * as styles from "./ServiceCard.css";

type ServiceCardProps = {
  index: number;
  title: string;
  summary: string;
  details: string;
};

export function ServiceCard({ index, title, summary, details }: ServiceCardProps) {
  return (
    <article className={styles.card}>
      <span className={styles.index}>{String(index).padStart(2, "0")}</span>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.summary}>{summary}</p>
      <p className={styles.details}>{details}</p>
    </article>
  );
}
